module.exports = __webpack_public_path__ + "img/ico_camera_drag_and_drop.b817f711.svg";